// Add your custom JS here.
import Header from './components/header';
import BurgerButton from './components/burger-button';
import Logo from './components/logo';
import Slider from './components/slider';
import ClickSlider from './components/click-slider';

( function() {
	'use strict';

    const header = new Header();
    const burgerButton = new BurgerButton();
    const logo = new Logo();

	const sliders = document.querySelectorAll('.flickity-slider') || null;
	let slidersArray = [];

	if ( sliders ) {
		sliders.forEach(s => {
			slidersArray.push(new Slider(s));
		});
	}

	let observerOptions = {
		// threshold: [0, 1]
	};

	// Observer for fade-in-me effect
	const observerEffectFade = new IntersectionObserver((entries) => {
		entries.map((entry, index) => {
			if (entry.isIntersecting) {
				setTimeout(() => {
					entry.target.classList.add('is-in-view');
					observerEffectFade.unobserve(entry.target);
				}, 250 * index);
			}
		});
	}, observerOptions);
	document.querySelectorAll('.fade-in-me').forEach(observable => observerEffectFade.observe(observable));


    // const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    // window.reducedMotion = reducedMotion.matches;


	const starsCanvas = document.getElementById('stars');

	if ( starsCanvas ) {
		const ctx = starsCanvas.getContext('2d');
		const starSize = 1;
		const numberOfStars = 100;

		if (ctx) {
			ctx.canvas.width  = window.innerWidth;
			ctx.canvas.height = window.innerHeight;

			let drawAllStars = function() {
				if (ctx && window.innerWidth >= 992) {
					for (let i = 0; i < numberOfStars; i++) {
						drawStar();
					}
				}
			};

			let drawStar = function() {
				if (ctx) {
					const x = getRandomInt(ctx.canvas.width);
					const y = getRandomInt(ctx.canvas.height);
					const starOpacity = getRandomInt(100) / 200;

					ctx.fillStyle = `rgba(255, 255, 255, ${starOpacity})`;

					const star = new Path2D(`M${x} ${y} h ${starSize} v ${starSize} h ${starSize} v ${starSize} h -${starSize} v ${starSize} h -${starSize} v -${starSize} h -${starSize} v -${starSize} h ${starSize} Z`);
					ctx.fill(star);
				}
			};

			let getRandomInt = function(max) {
				return Math.floor(Math.random() * max);
			};

			drawAllStars();
		}
	}

	const clickSlider = document.querySelectorAll('.click-slider')
	if ( clickSlider ) {
		clickSlider.forEach( slider => {
			return new ClickSlider(slider)
		})
	}


    window.dispatchEvent(new Event('scroll'));

    window.addEventListener('stickyHeader.show', ev => {
      // console.log(ev);
    });

} )();

(function($) {
	'use strict';
	function eventFire(el, etype){
		if (el.fireEvent) {
			el.fireEvent('on' + etype);
		} else {
			var evObj = document.createEvent('Events');
			evObj.initEvent(etype, true, false);
			el.dispatchEvent(evObj);
		}
	}



	// Google Map Function
	$.fn.googleMap = function(options) {
		var el = $(this);

		var settings = $.extend({
			'lat': '37.979561',
			'lng': '23.728487',
			'zoom': 13,
			'styles': '',
			'places_categories': false,
			'locations': [{
				lat: -33.890542,
				lng: 151.274856,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, options);

		var markers = [];
		var markersInit = [];
		var bounds = new google.maps.LatLngBounds();
		var directionsDisplayOptions = {
			suppressMarkers: true
		};
		var directionsService = new google.maps.DirectionsService;
		var directionsDisplay = new google.maps.DirectionsRenderer;
		directionsDisplay.setOptions( directionsDisplayOptions );

		// var offsetHeight = $('nav.navbar').position();
		var offsetHeight = $('nav.navbar').height() * 2;

		var map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {

			var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			var infoButtonString = "";
			var infoImageUrl = "";
			var markerInfowindow = false;
			var icon = false;

			if (attr.info_btn_url) {
				infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
			}

			if (attr.image_src) {
				infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					fillColor: '#7b7480',
					// anchor: new google.maps.Point(-200, -200),
					scaledSize: new google.maps.Size(36, 36),
					// strokeWeight: 0,
					scale: 0.5,
					// rotation: 0
				};
			}

			if (attr.info_text || attr.info_title) {
				var contentString =
					'<div class="map-infowindow">' +
					infoImageUrl +
					'<div class="main-gmap">' +
					'<h3 class="text-dark">' + attr.info_title + '</h3>' +
					'<div class="text-dark">' + attr.info_text +
					infoButtonString +
					'</div>' +
					'</div>' +
					'</div>';

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			var marker = add_marker(icon,locLatLng,markerInfowindow);

			markers.push(marker);
			clearMarkers();
			marker.addListener('click', function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			if (offsetHeight) {
				map.panBy(0, -offsetHeight);
			}

			bounds.extend(locLatLng);

			if (attr.routes) {
				if (Object.keys(attr.routes).length > 1) {

					var routeLocLatLng = new google.maps.LatLng(attr.routes[0].lat, attr.routes[0].lng);
					if (i === '1') {
						markersInit.push(add_marker(icon, locLatLng, markerInfowindow));
						markersInit.push(add_marker(icon, routeLocLatLng, markerInfowindow));
						calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
					}
					let location_pills = $('#location-pills-tab .location-tab-item-action');
					for ( let i=0; i < location_pills.length; i++) {
						if ( !location_pills[i].hasAttribute('hasListener') ) {
							location_pills[i].setAttribute('hasListener', 'true');
							location_pills[i].addEventListener('click', function (e) {
								clearMarkersInit(null);
								setTimeout(() => {eventFire(document.querySelector('.show .routes-tab .routes-tab-item-action.active'), 'click')}, 500);
							});
						}
					}

					let location_btn = $('.routes-tab .routes-tab-item-action');
					for ( let i=0; i < location_btn.length; i++) {
						location_btn[i].addEventListener('click', function (e) {
							var elId = $(this).attr('id');
							$.each(attr.routes, function (k, routeAttr) {
								if (elId === 'pills-' + routeAttr.title.toLowerCase() + '-tab') {
									clearMarkersInit(null);
									clearMarkers();
									var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);

									markers.push(add_marker(icon, locLatLng, markerInfowindow));
									markers.push(add_marker(icon, routeLocLatLng, markerInfowindow));

									calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
								}
							});
						});
					}
				}
			}
			console.log(markers)
		});

		function add_marker(icon,marker_position,markerInfowindow) {
			return new google.maps.Marker({
				position: marker_position,
				map: map,
				icon: icon ? icon : '',
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});
		}

		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}
		else if (Object.keys(settings.locations).length === 1) {
			map.setZoom(settings.zoom);
		}

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
			directionsService.route({
				origin: start,
				destination: end,
				travelMode: 'DRIVING'
			}, function(response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
					directionsDisplay.setMap(map);
				} else {
					window.alert('Directions request failed due to ' + status);
				}
			});
		}

		// Removes the markers from the map, but keeps them in the array.
		function clearMarkers() {
			setMapOnAll(null);
		}

		// Sets the map on all markers in the array.
		function setMapOnAll(map) {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(map);
			}
		}

		// Sets the map on all markers in the array.
		function clearMarkersInit(map) {
			for (var i = 0; i < markersInit.length; i++) {
				markersInit[i].setMap(map);
			}
		}
	};

	$.fn.scrollAnimations = function( options ) {
		/*
		 * Lets you apply one or more css transform functions to the selected elements.
		 * The value will depend on the position of the element.
		 * Given a starting value for when the element enters the screen and an end value for when it leaves.
		 * options can be given as parameter or set in html as data-smooth-scroll value.
		 * The format is {"property": propertyName,"start": startValue,"end": endValue}
		 * for example:
		 * <div data-smooth-scroll='{"property": "translateY","start":"180px","end":"-180px"}'>
		 * will make the div enter the screen 180px lower that its normal position and leave 180px higher,
		 * therefore it will scroll faster than the rest of the page.
		 * More than one transforms can be set on the same element as an array:
		 * <div data-smooth-scroll='[{"property": "translateY","start":"180px","end":"-180px"},{"property": "scale","start":"1","end":"1.45"}]'>
		 *
		 */


		// Helper function.
		// Get a number num that is between in_min and in_max and transform it into a number between out_min and out_max
		let scale = function(num, in_min, in_max, out_min, out_max) {
			return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
		};

		// Helper function.
		// Takes a number with units (12px) and returns an array [12, 'px'].
		let parseUnit = function(str) {
			let output = [];
			str = String(str);
			output[0] = parseFloat(str);
			output[1] = str.match(/[\d.\-+]*\s*(.*)/)[1] || '';
			return output;
		};

		return this.each(function() {
			let $item = $(this);
			let $window = $(window);

			if ( 920 > $window.outerWidth() ) return;

			// Interpolate current value of transform.
			let getTransformValues = function($item) {

				let scrollPosition = $window.scrollTop();

				let element_height = $item.outerHeight();
				let element_top_position = $item.offset().top;
				let element_bottom_position = (element_top_position + element_height);

				let animationSettings;
				if ( $item.data('smooth-scroll') ) {
					animationSettings = $item.data('smooth-scroll');
				} else if (options) {
					animationSettings = options;
				}

				if ( $.isArray(animationSettings) ) {
					animationSettings.forEach(function(setting){
						let start = parseUnit(setting.start)[0];
						let end = parseUnit(setting.end)[0];
						let unit = parseUnit(setting.start)[1];
						let current = scale(scrollPosition, (element_top_position - $window.height()), element_bottom_position, start, end);
						setting.current = current.toString() + unit;
					});
				} else {
					let start = parseUnit(animationSettings.start)[0];
					let end = parseUnit(animationSettings.end)[0];
					let unit = parseUnit(animationSettings.start)[1];
					let current = scale(scrollPosition, (element_top_position - $window.height()), element_bottom_position, start, end);
					animationSettings.current = current.toString() + unit;
				}

				return animationSettings;
			};

			// Write interpolated value as transform property.
			let writeTransformProperty = function($item) {
				let value = '';
				let animationSettings = getTransformValues($item);

				if ( $.isArray(animationSettings) ) {
					animationSettings.forEach(function(setting) {
						let transform = setting.property + '(' + setting.current + ') ';
						value = value.concat(transform);
					});
				} else {
					value = animationSettings.property + '(' + animationSettings.current + ') ';
				}
				return value;
			};

			// Check if element is in view and write transform css.
			let runAnimations = function() {
				let window_height = $window.height();
				let window_top_position = $window.scrollTop();
				let window_bottom_position = (window_top_position + window_height);

				let element_height = $item.outerHeight();
				let element_top_position = $item.offset().top;
				let element_bottom_position = (element_top_position + element_height);

				if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
					$item.css('transform', function() {
						return writeTransformProperty($item);
					});
				}
			};

			// Run animation on every scroll and resize.
			$window.on('scroll resize', runAnimations);
			$window.trigger('scroll');

			// Run animation on requestAnimationFrame.
			return this;
		});
	};

	/**
	 * Video Gallery Modals
	 */
	let $modals = $('.modal');
	if ($modals.length > 0) {
		$modals.each(function(){
			let src = $(this).find('iframe, video').attr('src');

			$(this).on('click', function(){

				if ($(this).find('video').length > 0) {
					$(this).find('video').get(0).pause();
				}
				$(this).find('iframe').attr('src', '');
				$(this).find('iframe').attr('src', src);

			});
		});
	}

	$('[data-smooth-scroll]').scrollAnimations();

})(jQuery);

$(document).ready( function() {
	'use strict';

	/**
	 * Google Map
	 */
	var $map = $('.map');
	if ($map.length > 0) {
		$map.each(function(){
			$(this).googleMap($(this).data('json'));
		});
	}

	/**
	 * Element Filtering
	 */
	let listingWrapper = $('.listing-wrapper');
	listingWrapper.imagesLoaded(
		function () {
			listingWrapper.isotope(
				{
					itemSelector: 'article',
				}
			);
		}
	);

	let filters = $('.filters');
	if (filters.length > 0) {

		filters.on('click', 'a', function() {
			let filterValue = $(this).attr('data-filter');
			listingWrapper.isotope(
				{
					filter: filterValue
				}
			);
		});
	}


	/* Page Gallery  */
	let listingRepeaterSlider = document.querySelectorAll('.inner-slider-wrapper .inner-slider');
	Array.from(listingRepeaterSlider).forEach((slider) => {
		let flkty = Flickity.data(slider);
		flkty.on('dragStart', function () {
			this.cells.forEach((cell) => {
				cell.element.style.pointerEvents = 'none';
			});
		});
		flkty.on('dragEnd', function () {
			this.cells.forEach((cell) => {
				cell.element.style.pointerEvents = 'all';
			});
		});
	});

	scrolledWindow();

	function scrolledWindow() {

		'use strict';

		let body = $('body');

		let scroll = $( window ).scrollTop();

		if (scroll >= 150 || window.innerWidth < 992) {
			body.addClass('scrolled');
		} else {
			body.removeClass('scrolled');
		}

	}

	/**
	 * Room Filtering (2 layer isotope filter)
	 */
	function filterRooms() {

		var $roomfilters = $('.room-filters');
		var $roomslist     = $('.room-listing-wrapper');
		var activeFilters = {};

		function concatValues( obj ) {
			var value = '';
			for ( var prop in obj ) {
				if ( '*' !== obj[ prop ] ) {
					value += obj[ prop ];
				}
			}
			return value;
		}

		function filter() {
			var selectedFiltersString = concatValues(activeFilters);

			if ( '' !== selectedFiltersString ) {
				var $open = $roomslist.children().filter(selectedFiltersString);
				$open.show(500);
				$roomslist.children().not($open).hide(500);
			} else {
				$roomslist.children().show(500);
			}
		}
		filter();

		$roomfilters.on(
			'click',
			'a',
			function () {
				var group            = $(this).data('filter-group');
				var $filtersInGroup  = $roomfilters.find('button').filter(
					function () {
						return $(this).data('filter-group') === group;
					}
				);
				$filtersInGroup.not(this).removeClass('is-active');
				$(this).addClass('is-active');
				activeFilters[group] = $(this).data('filter');
				filter();
				setTimeout(function(){
					let items = document.querySelectorAll('.room-listing-wrapper .card:not([style*="display: none"])');
					for (let i=0; i<items.length; i++) {
						if ( i % 2 == 0 ) {
							items[i].querySelector('.ordered-element').classList.add('order-lg-last');
						}
						else {
							items[i].querySelector('.ordered-element').classList.remove('order-lg-last');
						}
					}
				}, 750);

			}
		);
	}
	filterRooms();

	/**
	 * Element Filtering
	 */
	function masonryGalleryInitialise() {
		let $gallery = $('.masonry-gallery');
		if ($gallery.length > 0) {
			if ($gallery.data('isotope')) {
				/**
				 * init Isotope after all images have loaded
				 */
				$gallery.imagesLoaded().progress( function() {
					$gallery.isotope('layout');
				});

				/**
				 * Filter items on button click
				 */
				$('.masonry-gallery-filters').on('click', 'li a', function() {
					if (typeof preloader === 'function') {
						$gallery.find('.gallery-item').preloader({
							loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
							fadeIn: 300,
							delay: 100
						});
					}

					$gallery.isotope({
						filter: $(this).attr('data-filter')
					});
				});
			} else if ($gallery.data('masonry')) {
				$gallery.imagesLoaded().progress( function() {
					$gallery.isotope('layout');
				});
			}
		}
	}

	masonryGalleryInitialise();

	let masonryWrapper = document.querySelector('.masonry-wrapper') || false

	if ( masonryWrapper ) {
		const man = new Isotope( masonryWrapper, {
			itemSelector: '.image-with-text-over',
			masonry: {
				gutter: 24,
			}
		})
	}

	// temp fix !
	window.addEventListener("resize", function () {
		setTimeout(function(){
			$('.masonry-wrapper').masonry({
				itemSelector: '.image-with-text-over', // the grid item selector
				masonry: {
					gutter: 24,
				}
			}).masonry("layout");
		}, 750);
	});
});
